// carousel directive
bookingApp.directive('skCarousel', function($swipe){
    return {
        template: '<div class="viewer" ng-swipe-left="swipedLeft()" ng-swipe-right="swipedRight()">' +
            '<div class="control control-left"><span class="glyphicon glyphicon-chevron-left"></span></div>' +
            '<div class="control control-right"><span class="glyphicon glyphicon-chevron-right"></span></div>' +
        '</div>',
        link: function(scope, element, attrs, controller){
            var photoCount = 0;
            var setupControls = function(){
                if(attrs.photo < (photoCount-1)){
                    attrs.nextPhoto = parseInt(attrs.photo) + 1;
                }
                if(attrs.photo > 0){
                    attrs.previousPhoto = parseInt(attrs.photo) - 1;
                }
            };
            var setupPropertyPhotos = function(){
                if(!scope.property.photos.length > 0){
                    return;
                }
                // setup the controls photo count data
                 photoCount = scope.property.photos.length;
                setupControls();
                // setup swipe for room photos
                scope.swipedLeft = function(){
                    setupControls();
                    attrs.photo = attrs.nextPhoto;
                    element.find('.viewer').css('background-image','url("'+scope.property.photos[attrs.photo].url+'")');
                };
                scope.swipedRight = function(){
                    setupControls();
                    attrs.photo = attrs.previousPhoto;
                    element.find('.viewer').css('background-image','url("'+scope.property.photos[attrs.photo].url+'")');
                };
                // set background image
                element.find('.viewer').css('background-image','url("'+scope.property.photos[attrs.photo].url+'")');

                // setup the controls
                element.find('.control-left').click(function(){
                    setupControls();
                    attrs.photo = attrs.previousPhoto;
                    element.find('.viewer').css('background-image','url("'+scope.property.photos[attrs.photo].url+'")');
                });
                element.find('.control-right').click(function(){
                    setupControls();
                    attrs.photo = attrs.nextPhoto;
                    element.find('.viewer').css('background-image','url("'+scope.property.photos[attrs.photo].url+'")');
                });
                return;
            };
            var setupRoomPhotos = function(){
                if(!scope.property.rooms[attrs.room].photos.length > 0){
                    return;
                }
                 // setup swipe for room photos
                    scope.swipedLeft = function () {
                        setupControls();
                        attrs.photo = attrs.nextPhoto;
                        element.find('.viewer').css('background-image', 'url("' + scope.property.rooms[attrs.room].photos[attrs.photo] + '")');
                    };
                    scope.swipedRight = function () {
                        setupControls();
                        attrs.photo = attrs.previousPhoto;
                        element.find('.viewer').css('background-image', 'url("' + scope.property.rooms[attrs.room].photos[attrs.photo] + '")');
                    };
                    // set background image
                    element.find('.viewer').css('background-image', 'url("' + scope.property.rooms[attrs.room].photos[attrs.photo] + '")');
                    // setup the controls photo count data
                    photoCount = scope.property.rooms[attrs.room].photos.length;
                    setupControls();
                    // setup the controls
                    element.find('.control-left').click(function () {
                        setupControls();
                        attrs.photo = attrs.previousPhoto;
                        element.find('.viewer').css('background-image', 'url("' + scope.property.rooms[attrs.room].photos[attrs.photo] + '")');
                    });
                    element.find('.control-right').click(function () {
                        setupControls();
                        attrs.photo = attrs.nextPhoto;
                        element.find('.viewer').css('background-image', 'url("' + scope.property.rooms[attrs.room].photos[attrs.photo] + '")');
                    });
                    return;
            };
            // watcher on attributes - to udpate photo from property to room and vice versa
            attrs.$observe('type', function(type){
                scope.setupCarouselType();
                if(type === 'property'){
                    setupPropertyPhotos();
                } else {
                    setupRoomPhotos();
                }
            });

            scope.$watch(function(){return attrs.photos }, function(newValue, oldValue){
                if(attrs.type === 'property') {
                    if (scope.property.photos.length > 0) {
                        setupPropertyPhotos();
                    }
                } else {
                    setupRoomPhotos();
                }
            });
            scope.setupCarouselType = function() {
                // setup button clicks
                if (attrs.type === 'room') {
                    if(scope.property.photos.length > 0)
                    {
                        setupRoomPhotos();
                    }
                    return;
                }
                else if (attrs.type === 'property') {
                    if (scope.property.photos.length > 0) {
                        setupPropertyPhotos();
                    }
                    return;
                }
                attrs.$observe('photos', function (val) {
                    if (scope.property.photos.length > 0) {
                        setupPropertyPhotos();
                    }
                });
            };
            scope.setupCarouselType();

        }
    }
});
bookingApp.directive('onRepeatDone',function(){
    return {
        scope: {
            val: '='
        },
        link: function(scope, element, attrs){
            scope.$emit(attrs['onRepeatDone'] || "repeat_done", element);
        }
    }
});